module.exports = __webpack_public_path__ + "images/calendar-approved.37d3cd99.png";